export default __webpack_public_path__ + "static/media/prize-6.e0855672.webp";